import { data_engine } from '../../data-manip/data-manip';
import { IDisposable, IObservable, IUrl, repo } from '@bi/core';
import {
  IColorPair,
  IColorResolver,
  IEntity,
  IGeo,
  ILocation,
  ILocationArea,
  ILocationCard,
  ILocationsHelper,
  IMapFill,
  IMetric,
  IMetricsHelper,
  IOptionsProvider,
  IPeriod,
  IPeriodInfo,
  IPeriodsHelper,
  IPreset,
  IRange, IRawVizelConfig, IStoplight, IStoplights,
  IStoplightsProvider,
  ISubspace,
  ISubspacePtr,
  ITitleResolver,
  IUnit, IValue, IVCPV,
  IVizelConfigDisplay,
  IVizelController, IVizelProperties,
  responses,
  tables
} from '../../defs/bi';
import type { IVizel } from '../../views/components/Vizel/Vizel';

/* 
                                           
 */
export interface IVizelConfig extends IRawVizelConfig {

  /* 
                                                  
   */
  getTitle(e: IEntity, v?: number, index?: number): string;
  /* 
                                                   
   */
  getFormat(e: IEntity): string;

  /* 
                
   */
  _dataset: IDatasetModel;

  /* 
                
   */
  dataset: IDatasetModel;
  /* 
                
   */
  /* 
                
   */
  hasOption(optionId: string): boolean;                                         //              
  /* 
                
   */
  getOptionCount(optionId: string): number;
  /* 
                
   */
  setOption(optionId: string, value: boolean): void;                            //           
  /* 
                
   */
  addOption(optionId: string): boolean;
  /* 
                
   */
  removeOption(optionId: string): boolean;                                      //                      
  /* 
                
   */
  getStoplight(v: number, vizelType?: string): IStoplight;
  /* 
                
   */
  getStoplights(vizelType?: string): IStoplights;

  /* 
                
   */
  getDataset(): IDatasetModel;

  /* 
                
   */
  getProperty(key): any;
  /* 
                
   */
  setProperty(key: string, value: any): void;

  /* 
                                                       
   */
  getLegendItem(e: IEntity, idx?: number): tables.ILegendItem;

  /* 
                
   */
  serialize(): tables.IRawVizelConfig;

  /* 
                
   */
  getColor(e: IEntity, v?: IValue, index?: number, colorPalette?: string[]): string | null;

  /* 
                
   */
  getBgColor(e: IEntity, v?: IValue, index?: number): string | null;

  /* 
                
   */
  getColorPair(e: IEntity, v?: IValue, index?: number, colorPalette?: string[]): IColorPair;

  /* 
                                   
   */
  clone(): IVizelConfig;

  /* 
                
   */
  getDisplay(vizelType?: string): IVizelConfigDisplay;

  /* 
                
   */
  getRange(): IRange;


  /* 
                
   */
  disableRange(): void;

  /* 
                
   */
  getUrl(): string;

  /* 
                
   */
  getBgImage(): string;

  dataSource?: tables.IDataSource;

  /* 
                                             
   */
  getVizelType(): string;

  /* 
                
   */
  setVizelType(vizelType: string): void;

  /* 
                
   */
  setTitle(title: string): void;

  /* 
                
   */
  getSubspacePtr(): ISubspacePtr;

  /* 
                
   */
  controller: IVizelController;
  //                                                                

  title?: string;
  description?: string;
  display?: tables.IRawVizelConfigDisplay;
  legend?: { [id: string]: tables.ILegendItem; };
  badValueColor?: string;
  goodValueColor?: string;
  normsMainColor?: string;
  onClickDataPoint?: string | any;
  onClick?: string | any;                   //                         
  cardId?: string;
  externalUrl?: IUrl;
  dashboardId?: number | string;
  dashId?: number | string;
  normStrategy?: string;
  context?: any;
  options?: string[]
  titleContext?: string[];
  report?: { title: string, output: string, template: string }[];

  /* 
                
   */
  colorResolver?: IColorResolver;
  /* 
                
   */
  titleResolver?: ITitleResolver;

  /* 
                
   */
  chartStyle: string;
  /* 
                
   */
  showLegend: boolean;
  /* 
                
   */
  visualMap?: any;

  /* 
                                         
   */
  getRaw(): tables.IRawVizelConfig;
}


export interface IDashlet extends IEntity {
  id: string;
  title: string;
  layout: string;           //       
  children: IDashlet[];

  getDataset(): IDatasetModel;

  getDashboard(): IDashboard;

  getFrame(): tables.IConfigFrame;

  getDescription(): string;

  getRawVizelConfig(): tables.IRawVizelConfig;

  isContainer(): boolean;

  isRoot(): boolean;

  //             
  legend: any;
}


export interface IDashletsHelper {
  dashboards: IDashboard[];
  dashboardTopics: tables.IDashboardTopic[];

  getDashboard(id: string): IDashboard;

  getDash(id: string): IDashlet;

  getDashes(): IDashlet[];
}

export interface IDashboard extends IEntity {
  id: string;
  title: string;
  topic_id: number;
  stateColor: string;
  srt: number;

  getRootDashes(): IDashlet[];

  getDashes(): IDashlet[];
}


export interface IConfigHelper {
  hasValue(key: string): boolean;

  getValue(key: string, defaultValue?: string): string;

  getStringValue(key: string, defaultValue?: string): string;

  getIntValue(key: string, defaultValue?: number): number;

  getFloatValue(key: string, defaultValue?: number): number;

  getBoolValue(key: string, defaultValue?: any): boolean;

  getEnumValue(key: string, values: string[], defaultValue?: string): string;

  getStringArray(key: string, defaultValue?: string[]): string[];

  getIntArray(key: string, defaultValue?: number[]): number[];

  getEnterUrl(datasetKey: string): IUrl;
}


export interface IDatasetModel {
  id: number;
  guid: string;
  //           
  //                    
  schema_name: string;
  title: string;
  description: string;
  //
  units: IUnit[];
  metrics: IMetric[];
  rootMetrics: IMetric[];
  presets: IPreset[];
  locationCards: ILocationCard[];
  locationAreas: ILocationArea[];
  locations: ILocation[];
  rootLocations: ILocation[];
  periods: IPeriod[];
  dashlets: repo.ds.IRawDashlet[];

  defaultMetrics: IMetric[];
  defaultLocations: ILocation[];
  defaultPeriods: IPeriod[];

  metricsHelper: IMetricsHelper;
  locationsHelper: ILocationsHelper;
  periodsHelper: IPeriodsHelper;
  dashletsHelper: IDashletsHelper;

  getDataProvider(): data_engine.IDataProvider;

  getConfigHelper(): IConfigHelper;

  getEnterUrl(): IUrl;

  /* 
                
             
                      
   */
  createVizelConfig(d: tables.IRawVizelConfig, view_class?: string): IVizelConfig;

  //                                                                                           

  getDatasetTitleTemplate(route: string): string;

  getBiQuery(): any;

  getConfigParameter(key: string, defaultValue?: string): string;  //                                         

  update(dataset: repo.adm.IRawDataset, storage: responses.ITables): void;

  M: (id: string) => IMetric;
  L: (id: string | number) => ILocation;
  P: (id: string) => IPeriod;

  getPeriodInfoByRange(startId: string, endId: string, type?: number): IPeriodInfo;
}


export interface IDatasetServiceModel {
  loading: boolean;
  error: string;
  dataset: IDatasetModel;
}

export interface IAxesOrder extends Array<string> {
  xs?: string;
  ys?: string;
  zs?: string;
  aas?: string;
  abs?: string;
  //       
}

export interface IDsState {
  loading?: boolean | number;
  error?: string;
  //
  autoscale: boolean;
  chartType: string;
  dash: IDashlet;
  dboard: IDashboard;
  geo: IGeo;
  locations: ILocation[];
  formulaLocations: ILocation[];
  axesOrder: IAxesOrder;
  mapfill: IMapFill;
  metrics: IMetric[];
  periodInfo: IPeriodInfo;
  periods: IPeriod[];
  preset: IPreset;
  route: string;
  mapMetricsPanelVisible: boolean;
  datasetTitle: string;
  datasetDescriptionHTML: string;
  dataset: IDatasetModel;
  customConfig: any;
}


export interface IDsStateService {
  getModel(): IDsState;

  getDataset(): IDatasetModel;

  getMaxParametersNumber(): number;

  getMaxLocationsNumber(): number;

  setMetrics(ms: IMetric[]): void;

  setPreset(p: IPreset): void;

  setPeriods(start: IPeriod, end: IPeriod, type: number);

  setFormulaLocations(ls: ILocation[]): void;

  setGeo(g: IGeo): void;

  setDboard(dboard: IDashboard): void;

  setDash(dash: IDashlet): void;

  setAxesOrder(ao: IAxesOrder): void;

  setAutoscale(autoscale: boolean): void;

  setMapfill(mf: IMapFill): void;

  setChartType(chartType: string): void;

  setCustomConfig(config: any): void;

  toggleParameter(p: IMetric): void;

  removeMetric(p: IMetric): void;

  toggleFormulaLocation(l: ILocation): void;

  removeFormulaLocation(l: ILocation): void;

  goToPlots(): void;

  setMapMetricsPanelVisible(mapMetricsPanelVisible: boolean): void;

  subscribe(items: string | string[], callback: any): IDisposable;

  subscribeUpdates(listener: (model: IDsState) => void): IDisposable;

  subscribeUpdatesAndNotify(listener: (model: IDsState) => void): IDisposable;

  unsubscribe(listener: (model: IDsState) => void): void;

  retain(): IDsStateService;

  release(): boolean;
}

//                  
export interface IVizelProps {
  readonly slideId?: string;
  readonly editDashletId?: number;
  readonly view_class: string;
  readonly schema_name: string;
  readonly cfg: IVizelConfig;
  /* 
                                           
   */
  readonly rawCfg: tables.IRawVizelConfig;
  readonly dp: data_engine.IDataProvider;
  readonly dataset: IDatasetModel;
  readonly subspace: ISubspace;
  readonly controller: IVizelController;
  readonly colorResolver: IColorResolver;
  readonly title?: string;

  readonly dashlet?: repo.ds.IRawDashlet;
  readonly dashlets?: repo.ds.IRawDashlet[];
  readonly editMode: '' | 'edt' | 'builder';
  readonly dashId?: string;
  readonly dashboardId?: number;
  //                                                                               

  readonly onVizelPropertiesChanged?: (property: IVizelProperties) => void;
  readonly onChangeDashlets?: (updated: Partial<repo.ds.IRawDashlet>[], deleted?: Array<string | number>) => any;
  readonly onEditDashlet?: (dashId: string | number) => void;
  readonly onCreateDashlet?: (dashlet: Partial<repo.ds.IRawDashlet>) => Promise<repo.ds.IRawDashlet>;
  readonly onUserChange?: (config: repo.ds.IRawDashlet['config'], reset?: boolean) => void;

  /* 
                
   */
  showLegend?: boolean;


  properties?: IVizelProperties;
  renderError?: (error: string) => any;
  renderLoading?: (loading: boolean) => any;
  //                                                     
  subspaceLoading?: boolean;
}

export interface IVizelClass {
  new(props: IVizelProps): IVizel;
}


export enum LoadingStatus {
  UNDEFINED,
  LOADING_FIRST_TIME,
  LOADING,
  NO_DATA,
  HAS_DATA,
}

export interface IModuleOptions {
  useSinglePeriod?: boolean;
  metricsPanel?: boolean;
  locationsPanel?: boolean;
  periodsPanel?: boolean;
}
